import { useSyncExternalStore } from "react";
import { Spin } from "antd";
import {
  getApiLoadingServerSnapshot,
  getApiLoadingSnapshot,
  subscribeApiLoading,
} from "../apiLoading";

export function GlobalApiLoading() {
  const loading = useSyncExternalStore(
    subscribeApiLoading,
    getApiLoadingSnapshot,
    getApiLoadingServerSnapshot,
  );
  if (!loading) {
    return null;
  }
  return (
    <div
      className="global-api-loading-overlay"
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading"
    >
      <Spin size="large" />
    </div>
  );
}
